const billingSubscriptionSchema = function (state, props) {
  return {
    "ui:order": [
      "billableId", "billableType",
      "planId",
      "startsOn", "trialEndsOn", "endsOn", "status",
      "billingEmail", "billingVatId",
      "peppolId", "deliverViaPeppol",
      "billingAddress",
      "*"
    ],

    "billableId": {
      "ui:field": "SimplePolymorphicSelectorField",
      "ui:options": {
        width: 8,
        types: [
          {
            entityName: "office",
            displayAttribute: (office) => office.name
          },
          {
            entityName: "employment",
            displayAttribute: (employment) => employment.name
          }
        ]
      }
    },
    "billableType": {
      "ui:widget": "hidden"
    },
    // belongs_to plan, picked by name (fetched via BillingSubscriptionForm).
    "planId": {
      "ui:field": "SelectorField",
      "ui:options": {
        width: 8,
        entityName: "billingPlan",
        displayAttribute: (plan) => `${plan.name} (${plan.kind})`
      }
    },
    "startsOn": {
      "ui:widget": "DateWidget",
      "ui:options": { width: 4 }
    },
    "trialEndsOn": {
      "ui:widget": "DateWidget",
      "ui:options": { width: 4 }
    },
    "endsOn": {
      "ui:widget": "DateWidget",
      "ui:options": { width: 4 }
    },
    "status": {
      "ui:widget": "select",
      "ui:options": {
        width: 4,
        selectOptions: [
          { key: 'active',    value: 'active',    text: 'Active' },
          { key: 'paused',    value: 'paused',    text: 'Paused' },
          { key: 'cancelled', value: 'cancelled', text: 'Cancelled' }
        ]
      }
    },
    "billingEmail":     { "ui:options": { width: 8 } },
    "billingVatId":     { "ui:options": { width: 8 } },
    "peppolId":         { "ui:options": { width: 8 } },
    "deliverViaPeppol": { "ui:widget": "CheckboxWidget", "ui:options": { width: 4 } },
    "billingAddress":   { "ui:field": "AddressPasteField", "ui:options": { width: 16 } }
  }
}

export default billingSubscriptionSchema
